import { createApiQuery } from "@/hooks/use-api-query";
import { get } from "@/libs/http";
import { LocationRes } from '@/types/api/user-auth/location.d';
import { ipLocationManager } from '@/libs/ip-location-manager';

export const getIpLocation = async (): Promise<LocationRes> => {
  // 先检查缓存
  const cached = ipLocationManager.getCachedLocation();
  if (cached) {
    return Promise.resolve(cached);
  }

  // 缓存不存在或已过期，从服务器获取
  const result = await get<LocationRes>('/user/auth/v1/location');
  // 保存到缓存
  ipLocationManager.setLocation(result);

  return Promise.resolve(result);
};

export const useGetIpLocation = createApiQuery(getIpLocation, () => ['ip-location']);

/**
 * 获取 IP 位置信息（带缓存）
 * 如果有缓存则直接返回，否则返回 null
 */
export const getCachedIpLocation = (): LocationRes | null => {
  return ipLocationManager.getCachedLocation();
};

/**
 * 获取格式化的 IP 位置字符串，用于请求头
 * 如果缓存失效，会在后台异步刷新
 */
export const getFormattedIpLocation = async (): Promise<LocationRes | null> => {
  return await ipLocationManager.getLocationWithBackgroundRefresh();
};

/**
 * 手动触发 IP 位置信息刷新
 * 用于需要立即获取最新位置信息的场景
 */
export const refreshIpLocation = async (): Promise<void> => {
  await ipLocationManager.refreshLocationIfNeeded();
};
